export default "__VITE_ASSET__BYTx$$HS__"